<template>
  <div class="marketingMail" >
    <!-- <el-row>
      <div class="studyEmail">
        学习如何发营销邮件 <el-button type="primary" plain class="liveEmail" size="mini"> <i class="iconfont icon-icon-bofangshipin"></i> 观看视频</el-button>
      </div>
    </el-row> -->
    <!-- 配置前 -->
    <div class="BeforeConfig" v-if="!$store.state.historySubscribeKit" >
      <el-row class="studyEmailConter">
        <div class="studyEmailConterText">营销邮件，高效营销获客利器</div>
        <!-- <img :src="`${imgRes}mailinit.png`" alt=""> -->
        <img src="@/assets/image/common/mailinit.png" alt="">
        <div class="studyEmailConterFoot">
          <div class="footTitle">
            购买套餐，加速你的客户开发效率
          </div>
          <div>
            <el-button  class="rightAway" type="primary" @click="rightAway">立即购买</el-button>
          </div>
          <!-- <div class="skip">
            <el-button type="text" @click="next">跳过</el-button>
          </div> -->
        </div>
      </el-row>
    </div>
    <div v-else>
      <!-- 邮件列表 -->
      <!-- 跳过配置 -->
      <el-row class="liveNodispose" v-if="supplierState.activationEdm==false">
        <el-col>
          <div class="NodisposeIcon"> <i class="iconfont icon-icon-tishi"></i> 发送营销邮件前，需要先配置你的发信域名，<el-button type="text" size="small" class="liveNodisposeText">请联系客服获取帮助</el-button></div>
        </el-col>
      </el-row>
      <!-- 完成配置 -->
      <!-- <el-row class="live">
        <el-col :span="18">
          <div>学习如何发营销邮件</div>
        </el-col>
        <el-col :span="6" class="liveBtn">
          <el-button >
            观看视频
          </el-button>
        </el-col>
      </el-row> -->
      <el-row class="search" :gutter="40">
        <el-col :span="4">
          <!-- <el-form-item> -->
            <el-button  type="primary" @click="createdMail" size="medium">新建营销邮件</el-button>
          <!-- </el-form-item> -->
        </el-col>
        <el-col :span="16">
          <el-row :gutter="12" class="searchData">
            <el-col :span="6">
              <el-input :placeholder="'营销任务/邮件主题'" v-model.trim="searchData.keyword" clearable>
                <i slot="prefix" class="el-input__icon iconfont icon-icon-fangdajing">
              </i></el-input>
            </el-col>
            <el-col :span="6">
              <el-select  v-model="searchData.state" :placeholder="'任务状态'" maxlength="200" clearable >
                <el-option
                  v-for="item in edm_state"
                  :key="item.codeValue"
                  :label="item.name"
                  :value="item.codeValue">
                </el-option>
              </el-select >
            </el-col>
            <el-col :span="12">
              <el-date-picker
                v-model="searchData.dateTimes"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="timestamp"
                clearable
                >
              </el-date-picker>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button @click="cancel">重置</el-button>
        </el-col>
      </el-row>
      <el-row class="list" >
        <div>
          <tableList ref="tableList" @updateRefresh="search" :tableData="tableData" :totalNum="totalNum" :pageSize="pageSize" :curPage="curPage"/>
        </div>
        <div class="pagetionStyle"> 
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="curPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes,prev,pager,next, jumper"
            :total="totalNum"
            ref="pagina"
            >
          </el-pagination>
        </div>
      </el-row>
    </div>
    <vipBoxDialog :vipCode="vipCode" ref="vipBoxDialog" />
  </div>
</template>

<script>
import tableList from "@/components/intellect-marketing/tableList"
import {edmSubjectList,supplierState} from"@/utils/api/edmSubject"
import { getDictByType, } from '@/utils/api/common.js';
import {imgRes} from "@/utils/config"
import { mapMutations } from 'vuex';
import vipBoxDialog from "@/components/common/VIPdialog"
export default {
components:{
  tableList,
  vipBoxDialog
},
  data(){
    return{
      searchData:{
        keyword:'',//主题
        state:'',//任务状态
        dateTimes:null,//日期
      },
      searchDataCopy:{
        keyword:'',//主题
        state:'',//任务状态
        dateTimes:null,//日期
      },
      curPage:1,
      pageSize:10,
      tableData:[],
      totalNum:0,
      edm_state:[],
      imgRes:imgRes,
      supplierState:{
        // allowMember:false,
        // activationEdm:false,
        // subscribeKit:false
      },
      vipCode:7002,//7001, "套餐可用额度不足" ,  7002, 套餐无可用额度,购买套餐
    }
  },
  methods:{
      ...mapMutations(['SET_SUPPLIERSTATE']),
    rightAway(){
      // this.$router.push({name: 'const-center-meal-choose'});
      const router = this.$router.resolve({
        name: 'const-center-meal-choose'
      })
      window.location.href = router.href
      console.log('立即购买')
    },
      // 翻页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize=val
      this.handleCurrentChange(1)
     
    },
    // 当前页
    handleCurrentChange(val) {
      this.curPage=val
      this.searchData= JSON.parse(JSON.stringify(this.searchDataCopy))
      this.getEdmSubjectList()
      const listEle= document.querySelector('.el-table__body-wrapper');
      listEle.scrollTop = 0;
    },
    // 创建邮件
    createdMail(){
      if(this.supplierState.availableQuantity==0){
        this.$refs.vipBoxDialog.centerDialogVisible=true
      }else{
        if(!this.supplierState.activationEdm){
          this.$message('发送营销邮件前，需要先配置你的发信域名。请联系客服员获取帮助!');
        }else{
          this.$router.push({
            name: 'created-mail',
            query: { type: 'created' }
          });
        }
      }
    },
    // 搜索
    search(){
      this.curPage=1
      this.searchDataCopy= JSON.parse(JSON.stringify(this.searchData))
      this.getEdmSubjectList()
    },
    // 重置
    cancel(){
      this.curPage=1
      this.pageSize=10
      this.searchData.keyword=''
      this.searchData.state=''
      this.searchData.dateTimes=null
      this.searchDataCopy= JSON.parse(JSON.stringify(this.searchData))
      this.getEdmSubjectList()
    },
    //获取列表数据
    async getEdmSubjectList(){
      this.$refs.tableList.loading=true
      const params={
        "curPage": this.curPage,
        "pageSize": this.pageSize,
        "attribute": "",
        "sortType": 0,
        "keyword": this.searchDataCopy.keyword,
        "state": this.searchDataCopy.state,
        "startTime": this.searchDataCopy.dateTimes!=null?this.searchDataCopy.dateTimes[0]:'',
        "endTime": this.searchDataCopy.dateTimes!=null?this.searchDataCopy.dateTimes[1]:'',
        "sortField": 0
      }
      const res=await edmSubjectList(params)
      this.tableData=res.rspPageData.list
      this.totalNum=res.rspPageData.totalNum
      this.$refs.tableList.loading=false
    },
    // 获取当前人的邮件状态
    async getSupplierState(){
      const res = await supplierState()
      this.supplierState=res.data
      this.SET_SUPPLIERSTATE(this.supplierState);
    },
    // 获取当前邮件发送的状态
    async getInitDictByType(){
      let prams=[{"key":"edm_state"}]
      const res=await getDictByType(prams)
      this.edm_state=res.data.codeMap.edm_state
    },
    // 跳过
    next(){
      this.supplierState.activationEdm=true
    }
  },
  mounted(){
    this.getSupplierState()
    this.getInitDictByType()
    this.getEdmSubjectList()
  },
}
</script>

<style lang="scss" scoped>

.marketingMail{
  min-height: calc(100vh - 96px);
    /**修改全局的滚动条*/
  /**滚动条的宽度*/
  ::-webkit-scrollbar {
    width: 6px;
  }
  // 滚动条的滑块
  ::-webkit-scrollbar-thumb {
    background-color: rgba(144,147,153,.3);
    border-radius: 3px;
  }
}
.list{
 background: #FFFFFF;
 margin-top: 4px;
 min-height: calc(100vh - 180px);
}

.studyEmail{
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #16181A;
  text-align: center;
  // margin-bottom: 16px;
  background: #F5F7FA;
  padding-bottom: 10px;
}
.liveEmail{
  margin-left: 16px;
  .iconfont{
    font-size: 12px;
  }
}    
// 配置前
.BeforeConfig{
  text-align: center;
  background:url('~@/assets/image/common/mailBj.png') no-repeat center 100% #FFFFFF;
  background-size:100% ;
  .studyEmailConter{
    // margin-top: 16px;
    // background: #FFFFFF;
    padding-top: calc(60 / 1200 * 100%);
    min-height: calc(100vh - 96px);
    .studyEmailConterText{
      font-family: SourceHanSansCN-Bold;
      font-weight: 700;
      font-size: 18px;
      color: #16181A;
      margin-bottom: calc(28 / 1200 * 100%);
    }
    img{
      // width: 468px;
      // height: 270px;
      width: calc(468 / 1200 * 100%);
      height: calc(270 / 1200 * 100%);
    }
    .conterTitle{
      font-family: SourceHanSansCN-Bold;
      font-weight: 700;
      font-size: 18px;
      color: #16181A;
      margin-bottom: calc(66 / 1200 * 100%);
    }
    .centreContent{
      // display: flex;
      text-align: center;
      .centreContentList{
        position: relative;
        width: 342px;
        margin: 0 auto;
        margin-bottom: 77px;
        right: -90px;
        text-align: left;
        .listUl{
          position: absolute;
          left: -130px;
          top: 40px;
          line-height: 42px;
        }
        .listRight{
          // width: 342px;
          .listRightImg{
            height: 140px;
          }
        }
      }
    }
    .studyEmailConterFoot{
      margin-top: calc(50 / 1200 * 100%);
      .footTitle{
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        font-size: 14px;
        margin-bottom: calc(16 / 1200 * 100%);
      }
      .skip{
        margin-top: 10px;
        .el-button--text{
          color: #4F5D78;
        }
      }
    }
  }
}
// 跳过配置
.liveNodispose{
  height: 36px;
  background: #ff7f2a1a;
  line-height: 36px;
  padding-left: 20px;
  margin-bottom:12px;
  color: #ff7f2aff;
  font-size: 12px;
  font-family: SourceHanSansCN;
  font-weight: 400;
  // border-bottom: 12px solid #F5F7FA;
  .NodisposeIcon{

    .iconfont{
      font-size: 12px;
    }
  }
  .liveNodisposeText{

  }
  .el-button--text{
    padding: 0;
    line-height: 36px;
  }
}

//完成配置
.live{
  height: 60px;
  background: #FFFFFF;
  line-height: 60px;
  padding-left: 20px;
  margin-bottom:12px;
  .liveBtn{
    text-align: center;
  }
}
.search{
  margin: 0 !important;
  background: #FFFFFF;
  padding: 20px 0px;
  .el-input__prefix{
    // left: 12px;
    .el-input__icon{
      font-size: 12px;
      margin-left: 7px;
    }
  }
  .searchData{
    .el-select{
      width: 100%;
    }
    .el-range-editor.el-input__inner{
      width: 100%;
    }
  }
}
.pagetionStyle{
  text-align: center;
  // margin-top: 30px;
  margin-bottom: 10px;
  ::v-deep .is-background{
    .btn-prev,.btn-next,.el-pager>li{
      background: #FFFFFF;
      border: 1px solid #CFD5DF;
      border-radius: 6px;
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active{
      background-color: #066EB7 !important;
    }
    // .btn-prev{
    //   background: #FFFFFF;
    //   border: 1px solid #CFD5DF;
    //   border-radius: 6px;
    // }
  }
}
.rightAway{
  width: 288px;
  height: 44px;
  background-image: linear-gradient(180deg, #FF8A3D 0%, #FF6600 100%);
  box-shadow: 0 2px 10px 0 #4a1f0033;
  border-radius: 4px;
  border: none;
}
</style>